import { render, staticRenderFns } from "./BaseSelectLanguage.vue?vue&type=template&id=198dd28a"
import script from "./BaseSelectLanguage.vue?vue&type=script&lang=js"
export * from "./BaseSelectLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports